.calendarHeader {
  .actionBar {
    display: flex;
    gap: var(--ixf-space-4);
    width: 100%;
    align-items: center;

    .arrowButton {
      display: inline-flex;
      cursor: pointer;
      flex: 0 0 16px;

      &:disabled {
        cursor: default;
        opacity: 0.3;
      }

      &.rotate {
        transform: rotate(180deg);
      }

      &.isUnused {
        visibility: hidden;
      }
    }

    .titleContainer {
      text-align: center;
      flex: 1 1 auto;
    }
  }

  .separator {
    width: 100%;
    height: 1px;
    border: none;
    background-color: var(--ixf-color-separator);
  }
}
